/** @format */

import getConfig from "next/config"
import { navigationToLoginPage } from "../shared/helpers"
import { displayToast } from "_stores/toast"
import Cookie from "js-cookie"
import { BFFClient } from "./BFFClient.generated"
import { isInUnifiedRouting } from "_shared/helpers/unifiedRoutingHelper"

const displayTechnicalErrorToast = () => {
	displayToast({
		type: "error",
		headerText: "Erreur technique",
		message: "Une erreur technique est survenue, veuillez réessayer.",
	})
}
const getApiBaseURl = () => {
	if (isInUnifiedRouting()) {
        return `/${process.env.NEXT_PUBLIC_UNIFIED_DEFAULT_PATH}`
    }
    else
    {
        const config = getConfig()
        return config.publicRuntimeConfig.apiBaseUrl;
    }
}

const fetchExtended = { 
	async fetch(url: string, init: RequestInit) {
        const baseUrl = getApiBaseURl();
        const fullUrl = `${baseUrl}${url}`

		const response = await fetch(fullUrl, {
			...init,
			credentials: "include",
		})
		switch (response.status) {
            case 401: {
                navigationToLoginPage()
                break
            }
            case 500: {
                console.error("bffClient error 500", response)
                displayTechnicalErrorToast()
                break
            }
            case 504: {
                console.error("bffclient gateway timeout", response)
                displayTechnicalErrorToast()
                break
            }
            default: {
                if(response.status.toString().startsWith("5")) {
                    console.error("bffClient error", response)
                    displayTechnicalErrorToast()
                }
                break
            }
        }
		return response
	},
}

const generateNewCorrelationId= (userAccessToken: string)=>
{
    if(!userAccessToken)
    {
        return crypto.randomUUID();
    }
    
    const rcuId = userAccessToken.split('+');
    return `${rcuId[11]}-${crypto.randomUUID()}`
}

const bffClient = new BFFClient("", fetchExtended)
export * from "./BFFClient.generated"
export default bffClient
